import React from "react";
import { TableColumn, TableRow } from "../../Styles";
import AiSkuMappingActions from "../AiSkuMappingActions";
import AiSkuMappingStatus from "../AiSkuMappingStatus";
import useDecideAiSkuMapping from "../hooks/useDecideAiSkuMapping";
import { LinkIcon } from "../Styles/Icons";
import { isMapped, isMappingReviewed } from "../helper";

export default function SkuMappingRow({ aiSkuMapping }) {
  const {
    _id: id,
    labProduct = {},
    dentiraProduct = {},
    status,
  } = aiSkuMapping;
  const { decideAiSkuMapping, decisionState, isEditing, setIsEditing } =
    useDecideAiSkuMapping(id, dentiraProduct, labProduct);

  const isReviewed = isMappingReviewed(decisionState);
  return (
    <TableRow key={id}>
      {/* Lab SKU */}
      <TableColumn>
        <div style={{ fontWeight: isReviewed ? 400 : 600, fontSize: "16px" }}>
          {labProduct.supplier_product_id}
        </div>
      </TableColumn>

      {/* Lab Product */}
      <TableColumn>
        <div style={{ fontWeight: isReviewed ? 400 : 600, fontSize: "16px" }}>
          {labProduct.name}
        </div>
      </TableColumn>

      <TableColumn>
        <div style={{ fontWeight: isReviewed ? 400 : 600, fontSize: "16px" }}>
          {isMapped(status) && <LinkIcon />}
        </div>
      </TableColumn>

      {/* Suggested Dentira Match */}
      <TableColumn>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <div style={{ fontWeight: isReviewed ? 400 : 600, fontSize: "16px" }}>
            {dentiraProduct.name}
          </div>
          <div
            style={{
              fontWeight: isReviewed ? 400 : 600,
              fontSize: "14px",
              color: "#666",
            }}
          >
            {dentiraProduct.description}
          </div>
        </div>
      </TableColumn>

      {/* Status */}
      <TableColumn>
        <AiSkuMappingStatus status={status} />
      </TableColumn>

      {/* Actions */}
      <TableColumn>
        <AiSkuMappingActions
          decideAiSkuMapping={decideAiSkuMapping}
          decisionState={decisionState}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      </TableColumn>
    </TableRow>
  );
}
